import { render, staticRenderFns } from "./PlaceSlider.vue?vue&type=template&id=1f208154&"
import script from "./PlaceSlider.vue?vue&type=script&lang=js&"
export * from "./PlaceSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports